import { useState } from "react";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Bitcou from "../../lib/Bitcou";
import Currencies from "../../lib/Currencies";
import { BrandItem } from "./BrandItem";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Alert } from "reactstrap"
import { CoinBase } from "../../lib/CoinBase";
import { Warning } from '@material-ui/icons';

export const Brand = (props) => {

    let selectedProduct;
    const { id } = useParams();
    const [state, setState] = useState({
        brand: null,
        loading: true,
        isVariablePrice: false,
        minPrice: 0,
        maxPrice: 0,
        requirePhone: false,
        currency: "",
        quantity: 1,
        redeemInstructions: "",
        terms: "",
        available: true,
        countries : [],
        recommendedAmounts : []
    });

    const [price, setPrice] = useState();
    const [similar, setSimilar] = useState([]);
    const [activeAccordion, setActiveAccordion] = useState();


    useEffect(() => {
        Bitcou.getBrand(id)
            .then((brand) => {
                console.log(brand)
                if (brand.products.length) {
                    brand.products.sort((p1, p2) => p1.fixedPrice - p2.fixedPrice);
                    const minPrice = brand.products[0].minVariablePrice;
                    const maxPrice = brand.products[brand.products.length - 1].maxVariablePrice;
                    const isVariablePrice = brand.products[0].isVariablePrice;
                    const requirePhone = brand.products[0].requirePhone;
                    const currency = brand.products[0].currency;
                    const redeemInstructions = brand.products[0].redeemInstructions;
                    const terms = brand.products[0].tc;
                    const available = brand.products.length > 1 || brand.products[0].available;
                    const countries = brand.products[0].countries.map(c => c.name);
                    brand.products = brand.products.filter(p => p.available);
                    let recommendedAmounts;
                    if(isVariablePrice){
                        recommendedAmounts = brand.products[0].recommendedAmounts.split(',').map(p => { return { price :  parseInt(p)}});
                    }
                    setState({
                        ...state, quantity: 1, brand, loading: false, minPrice, maxPrice, countries,
                        isVariablePrice, requirePhone, currency, redeemInstructions, terms, available, recommendedAmounts
                    });
                } else {
                    setState({ ...state, quantity: 1, brand, loading: false })
                }
                if (brand.products.length) {
                    Bitcou.getSimilar(brand.products[0].id)
                        .then((brands) => {
                            setSimilar(brands)
                        })
                        .catch(() => { });
                }
            })
            .catch((e) => { console.log(e); alert("An error has occured") });

    }, [id])

    const increaseQty = () => setState({ ...state, quantity: state.quantity + 1 })
    const decreaseQty = () => state.quantity > 1 && setState({ ...state, quantity: state.quantity - 1 })

    const selectProduct = (p) => selectedProduct = p;

    const choosePrice = ({ target }) => {
        setPrice(parseInt(target.value))
        console.log(target.value);
    }

    const addToCart = () => {
        if (!state.isVariablePrice) {
            if (!selectedProduct) {
                return alert("Please select a product to add to your cart");
            }
            props.addToCart(selectedProduct, state.quantity, selectedProduct.fixedPrice, selectedProduct.eurFixedPrice);
        } else {
            CoinBase.GetRate(state.currency, "EUR")
                .then((rate) => {
                    props.addToCart(state.brand.products[0], state.quantity, price, price * rate);
                })
                .catch(() => alert('An error has occured'));
        }
    }

    const toggleAccordion = (item) => {
        if (activeAccordion == item)
            setActiveAccordion("")
        else setActiveAccordion(item);
    }

    return state.brand ?
        (
            <>
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-md-4 col-sm-12">
                            <img src={state.brand.brandImageURL} className="img-fluid" />
                        </div>
                        <div className="col-md-1 col-sm-0"></div>
                        <div className="col-md-7 col-sm-12">
                            <div className="row">
                                <div className="col" style={{ marginBottom: 50 }}>
                                    <h2 className="brand-name mb-4">{state.brand.brandName}</h2>
                                    <div className="mb-4">
                                        <span className="h5">Available in : </span>
                                        <span style={{ wordBreak : "break-word" }}>{state.countries.join(',')}</span>
                                    </div>
                                    {state.brand.products.length && (<p dangerouslySetInnerHTML={{ __html: state.brand.products[0].description }}></p>)}
                                </div>
                            </div>
                            {state.brand.products.length && (
                                <>
                                    {state.available ? (
                                        <>
                                            <div className="row mb-4">
                                                <div className="col-md-7 col-sm-12">
                                                    {state.isVariablePrice ? <h4>Pick Price</h4> : <h4>Product</h4>}
                                                    {state.isVariablePrice ? (
                                                        <div className="d-flex">
                                                            <div class="input-group input-group-lg" style={{ flex: 1, width : "auto" }} >
                                                                <input className="form-control open-font-condensed" placeholder="Choose the amount"onChange={choosePrice} />
                                                                <span class="input-group-text open-font-condensed justify-content-center" style={{ minWidth : 60 }}>
                                                                    { Currencies.GetSymbol(state.currency) }
                                                                </span>
                                                            </div>
                                                            <div style={{ marginLeft: 30, width : 100 }}>
                                                                <div className="open-font-condensed">Min : {state.minPrice} {Currencies.GetSymbol(state.currency)}</div>
                                                                <div className="open-font-condensed">Max : {state.maxPrice} {Currencies.GetSymbol(state.currency)}</div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Select className="select select-lg" onChange={selectProduct} options={state.brand.products} getOptionValue={o => o.id}
                                                            formatOptionLabel={o => o.fixedPrice + ' ' + Currencies.GetSymbol(state.currency)}>
                                                        </Select>
                                                    )}
                                                </div>
                                                {state.isVariablePrice && state.recommendedAmounts.length > 0 && (
                                                    <div className="col-md-5 col-sm-12">
                                                        <h5 className="mt-4">Or choose from recommended</h5>
                                                        <Select className="select select-lg" onChange={({ price : value }) => choosePrice({ target : { value } })} options={state.recommendedAmounts}
                                                            getOptionValue={o => o.price} formatOptionLabel={o => o.price + ' ' + Currencies.GetSymbol(state.currency)}>
                                                        </Select>
                                                    </div>
                                                )}
                                            </div>
                                            <h4>Quantity</h4>
                                            <div className="row mb-5">
                                                <div className="col-md-4 col-6">
                                                    <div className="number-input">
                                                        <button onClick={decreaseQty}></button>
                                                        <input type="text" name="amount" className="auto-number" value={state.quantity} readOnly={true} />
                                                        <button onClick={increaseQty} className="plus"></button>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <button className="btn-yellow w-100" onClick={addToCart}>Add to Cart</button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <Alert color="warning" className="mb-4">
                                            <h5 className="mb-0">This product is currently unavailable</h5>
                                        </Alert>
                                    )}
                                    <Link className="btn btn-black-outline mb-3" to={`/support?brand=${state.brand.variantID}&brandName=${state.brand.brandName}`}>
                                        <Warning style={{ marginBottom : 5, marginRight : 10 }}/>
                                        Report a problem with this product
                                    </Link>
                                    <div>
                                        <Accordion flush open={activeAccordion} toggle={toggleAccordion}>
                                            <AccordionItem>
                                                <AccordionHeader targetId="1">
                                                    <h5>Redeem Instructions</h5>
                                                </AccordionHeader>
                                                <AccordionBody accordionId="1">
                                                    <div dangerouslySetInnerHTML={{ __html: state.redeemInstructions }}></div>
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem>
                                                <AccordionHeader targetId="2">
                                                    <h5>Terms and Conditions</h5>
                                                </AccordionHeader>
                                                <AccordionBody accordionId="2">
                                                    <div dangerouslySetInnerHTML={{ __html: state.terms }}></div>
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Accordion>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="row mb-3" style={{ marginTop: 50 }}>
                        <div className="col">
                            <h3>Similar products</h3>
                        </div>
                    </div>
                    <div className="brands mb-5">
                        <div className="row">
                            {similar.map((brand) => (
                                <div className="col-3 flex-center-content ">
                                    <BrandItem key={brand.id} brand={brand} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        ) : <></>;
}